import dayjs from 'dayjs';

/**
 * 진척률
 * @param progRt  진척률 (소수점 1자리까지 버림 표현 (반올림 시 99.9 -> 100% 표현 막기 위해 버림으로 처리))
 */
export const getProgressRate = (progRt = 0) => {
  return `${Math.floor(Number(progRt) * 10) / 10}%`;
};

/**
 * 진척률 타이틀 (ex. 10% (D+10))
 *
 * @param progRt    진척률 (소수점 1자리까지 버림 표현 (반올림 시 99.9 -> 100% 표현 막기 위해 버림으로 처리))
 * @param delay     지연일수
 */
export const getProgressRateTitle = (progRt = 0, delay = 0) => {
  // 소수점 1자리까지 버림 표현 (반올림 시 99.9 -> 100% 표현 막기 위해 버림으로 처리)
  let title = getProgressRate(progRt);
  if (delay > 0) {
    title = `${title} (D+${delay.toLocaleString()})`;
  }
  return title;
};

/**
 * 계획 진척률 계산
 * @param planStDt
 * @param planEndDt
 */
export const getPlanProgressRate = (planStDt = '', planEndDt = '') => {
  if (!planStDt || !planEndDt) return '';

  const startDt = dayjs(planStDt);
  const endDt = dayjs(planEndDt);
  const planDay = endDt.diff(startDt, 'day') + 1;
  const curDay = dayjs().diff(startDt, 'day') + 1;
  const planProgRt = Math.max(Math.min((curDay / planDay) * 100, 100), 0);
  return getProgressRate(planProgRt);
};
